module.exports = __webpack_public_path__ + "components/rewards/ski-line/static/logo-504dc45666af32880edb776c183bf829.jpg";